import * as Types from '../constants/Types';

export const getListAmenity = (filters) => ({ type: Types.AMENITY_LIST_ACTION, filters });
export const setListAmenity = (amenities) => ({ type: Types.AMENITY_LIST_SUCCESS, amenities});

export const getAmenityDetail = (id) => ({ type: Types.AMENITY_DETAIL_ACTION, id })
export const setAmenityDetail = (amenity) => ({ type: Types.AMENITY_DETAIL_SUCCESS, amenity });

export const updateAmenityDetail = (amenity) => ({ type: Types.AMENITY_DETAIL_UPDATE_ACTION, amenity });
export const createAmenityDetail = (amenity) => ({ type: Types.AMENITY_DETAIL_CREATE_ACTION, amenity });
export const deleteAmenityDetail = (amenity, filters) => ({ type: Types.AMENITY_DETAIL_DELETE_ACTION, amenity, filters });

export const createAmenityTranslate = (amenity) => ({type: Types.AMENITY_CREATE_TRANSLATE_ACTION, amenity});
export const updateAmenityTranslate = (amenity) => ({type: Types.AMENITY_UPDATE_TRANSLATE_ACTION, amenity});
export const deleteAmenityTranslate = (amenity, refreshParams) => ({type: Types.AMENITY_DELETE_TRANSLATE_ACTION, amenity, refreshParams});